import './EmptyState.css';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  children?: React.ReactNode;
}

/**
 * 空狀態元件
 * 對應 UXC-common-EmptyState-005
 */
const EmptyState = ({
  icon = '📭',
  title,
  description,
  action,
  children,
}: EmptyStateProps) => {
  return (
    <div className="empty-state">
      <div className="empty-state__icon">{icon}</div>
      <h3 className="empty-state__title">{title}</h3>
      {description && <p className="empty-state__description">{description}</p>}
      {action && (
        <button className="empty-state__action" onClick={action.onClick}>
          {action.label}
        </button>
      )}
      {children && <div className="empty-state__content">{children}</div>}
    </div>
  );
};

export default EmptyState;
